import { DeliveryTypeRequest, DeliveryTypeResponse } from './data-contracts';
import { ContentType, HttpClient, RequestParams, TraceDataType } from './http-client';

import { loggerCan } from '@/data/utils/loggerUtil';
import { logger } from '@/logging/logger';

export class DeliveryType<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
	}

	/**
	 * No description
	 *
	 * @tags DeliveryType
	 * @name DeliveryType
	 * @request POST:/store/{storeId}/cart/@self/deliveryType
	 * @response `200` `DeliveryTypeResponse` Successfully updated delivery type
	 */
	deliveryType = (
		storeId: string,
		query: {
			/** @default "json" */
			responseFormat: string;
			/** @default "-5" */
			langId: string;
		},
		data: DeliveryTypeRequest,
		params: RequestParams = {}
	) => {
		const { _requestId: requestId, skipErrorLogging, ..._params } = params as any;
		let traceData: TraceDataType | undefined;

		if (loggerCan('trace') && (!this.http.traceDetails || this.http.traceDetails['deliveryType'])) {
			traceData = {
				requestId,
				msg: 'API request',
				url: `${this.http.baseUrl}/store/${storeId}/cart/@self/deliveryType`,
				params: _params,
				query: query,
				body: data,
				methodName: 'deliveryType',
			};
			logger.trace(traceData);
		}
		return this.http.request<DeliveryTypeResponse, any>({
			path: `/store/${storeId}/cart/@self/deliveryType`,
			method: 'POST',
			query: query,
			body: data,
			type: params.type ?? ContentType.Json,
			format: params.format ?? 'json',
			storeId,
			traceData,
			skipErrorLogging,
			..._params,
		});
	};
}
